let ft_dataset = {};

document.addEventListener("turbo:load", () => {
  const container = document.getElementById("finalize_transaction");
  if (!container) return;

  console.log("Load: donations/finalize_transaction.js");

  ft_dataset = container.dataset;

  if (ft_dataset.formType === "donation") {
    bindDonationEvents();
  } else if (ft_dataset.formType === "cart") {
    bindCartEvents();
  } else if (ft_dataset.formType === "registration") {
    bindRegistrationEvents();

    // Always initialize donation fundraiser if "yes" is default selected
    const selectedDonation = document.querySelector('input[name="choose_donation"]:checked');

    if (selectedDonation && selectedDonation.value === "yes") {
      const fundraiserId = selectedDonation.getAttribute("data-fundraiser-id");
      if (fundraiserId) {
        document.getElementById("donation_fundraiser_id").value = fundraiserId;
        document.getElementById("donation_options").classList.remove("d-none");
      }
    }
  }
});

/* -------------------------------------------------------------------------- */
/* Bind events                                                                */
/* -------------------------------------------------------------------------- */

function bindCartEvents(){
  console.log("binding cart events");

  $("#payment_method").off("change", togglePaymentProcessor);
  $("#payment_method").on("change", togglePaymentProcessor);
}

function bindDonationEvents() {
  console.log("binding donation events");
  bindCommonEvents();

  $('#switch_fundraiser_id').off("change");
  $('#switch_fundraiser_id').on("change", function () {
    $('#donation_fundraiser_id').val($(this).val());
  });

  $(document).off("change", "#donation_company_id");
  $(document).on("change", "#donation_company_id", function () {
    const opt = this.options[this.selectedIndex];
    const match = opt.dataset.companyMatch;

    if (match === "true") {
      $("#has_company_match").removeClass("d-none");
      $("#no_company_match").addClass("d-none");

      $("#company_match_description").text(opt.dataset.companyMatchDescription || "");

      if (opt.dataset.companyEmployeeIdentifier) {
        $("#company_employee_identifier_value").text(opt.dataset.companyEmployeeIdentifier);
        $("#company_employee_identifier_field").removeClass("d-none");

      } else {
        $("#company_employee_identifier_field").addClass("d-none");
      }

    } else {
      $("#has_company_match").addClass("d-none");
      $("#no_company_match").removeClass("d-none");
      $("#company_employee_identifier_field").addClass("d-none");
    }
  });

  // trigger select state
  $("#donation_company_id").trigger("change");
}

function bindRegistrationEvents() {
  console.log("binding registration events");
  bindCommonEvents();

  checkRegOptions();
  checkDynamicRegOptions();

  if ($('.form')) {
    $('.form :input').each(function () {
      getDependencies($(this));
    });
  }

  $('.form').off("change");
  $('.form').on("change", function (e) {
    getDependencies($(e.target));
  });

    // Apply coupons
  $('#apply_coupon').off("click");
  $('#apply_coupon').on("click", function (e) {
    e.preventDefault();
    applyCoupon();
    return false;
  });

  $('#coupon_code').off("keydown");
  $('#coupon_code').on("keydown", function (e) {
    if (e.which === 13) {
      e.preventDefault();
      applyCoupon();
      return false;
    }
  });

  $('#choose_team').off("change");
  $('#choose_team').on("change", function () {
    if ($(this).val() === "new") {
      $('#options_new_team').slideDown('fast');
    } else {
      $('#options_new_team').slideUp('fast');
      clearFields($('#options_new_team'));
    }
  });

  $('#options_activity').off("change");
  $('#options_activity').on("change", function (e) {
    const id = $(e.target).data('activity-id');
    const divisions = $('#options_division .form_field_radio');

    $.each(divisions, function (_index, value) {
      const divisionField = $(value);
      const validFor = divisionField.data('valid-for');

      if (validFor.indexOf(id) === -1) {
        divisionField.slideUp('fast');
        clearFields(divisionField);
      } else {
        divisionField.slideDown('fast');
      }
    });
  });

  $('.select_any_option_once select').off("change");
  $('.select_any_option_once select').on("change", function (e) {
    const target = $(e.target);
    const parent = target.closest('.select_any_option_once');

    parent.find('option').each(function () {
      $(this).prop('disabled', false);
    });

    parent.find('select').each(function () {
      const thisSelect = $(this);
      const otherSelects = parent.find('select').not(thisSelect);
      const selected = thisSelect.val();

      const disableOptions = otherSelects.find('option').filter(function () {
        return $(this).val() === selected;
      });

      disableOptions.each(function () {
        $(this).prop('disabled', true);
      });
    });
  });

  $('#choose_nonprofit').off('change');
  $('#choose_nonprofit').on('change', function () {
    const id = $(this).val();
    const chooseTeam = $('#choose_team');
    chooseTeam.val("");

    if (id !== "") {
      $.getJSON("/list_fkids/" + id, function (childFundraisers) {
        if (childFundraisers.length > 0) {
          chooseTeam.children().each(function () {
            if (childFundraisers.indexOf(parseInt($(this).val())) === -1) {
              $(this).prop("disabled", true).prop("hidden", true);
            } else {
              $(this).prop("disabled", false).prop("hidden", false);
            }
          });
          chooseTeam.removeClass('d-none');
        } else {
          chooseTeam.children().each(function () {
            $(this).prop("disabled", true).prop("hidden", true);
          });
          chooseTeam.addClass('d-none');
        }
      });
    } else {
      chooseTeam.children().each(function () {
        $(this).prop("disabled", false).prop("hidden", false);
      });
      chooseTeam.removeClass('d-none');
    }
  });

  $(document).off("change", 'input[name="choose_donation"]');
  $(document).on("change", 'input[name="choose_donation"]', function () {
    let val = $(this).val(); // should be "no" or "yes"

    if (val === "no") {
      $('input[name="amount_btn"]').prop("checked", false);
      $("#amount_input").val("0");
      changeAmount(0);
    }
  });

  $('#choose_nonprofit, #choose_donation_fundraiser').off('change');
  $('#choose_nonprofit, #choose_donation_fundraiser').on('change', function () {
    const id = $(this).val();

    if (id !== "") {
      const name = $(this).find('option:selected').text();
      $('#donation_fundraiser_id').val(id);
      $('#amount_input_label').text("Make a donation to " + name + " (optional)");
      $('#donation_options').slideDown();
    } else {
      $('#donation_fundraiser_id').val("");
      $('#donation_options').slideUp();
    }
  });

  $('input[name="support_nonprofit"]').off('change');
  $('input[name="support_nonprofit"]').on('change', function () {
    if ($(this).val() === "yes") {
      $('#options_choose_donation_section').slideUp();
    } else {
      $('#options_choose_donation_section').slideDown();
    }
  });

  $('input[name="support_nonprofit"], input[name="choose_donation"]').off('change');
  $('input[name="support_nonprofit"], input[name="choose_donation"]').on('change', function () {
    // only act if THIS radio is the one selected
    if (!$(this).prop('checked')) return;

    if ($(this).val() !== "yes") {
      $('#donation_options').slideUp();
      $('#donation_fundraiser_id').val("");
    }
  });

  $('.reg_options').off('change');
  $('.reg_options').on('change', checkRegOptions);

  $('.registration_field').off('blur keydown input change');
  $('.registration_field').on('blur keydown input change', checkDynamicRegOptions);

  $('.registration_cost_field').off('change');
  $('.registration_cost_field').on('change', checkDynamicRegOptions);

  const possibleRegFieldIDs = {
    '#registration_First_name': '#user_first_name',
    '#registration_Last_name': '#user_last_name',
    '#registration_Email': '#user_email',
    '#registration_Phone': '#user_phone',
    '#registration_Address': '#user_address1',
    '#registration_City': '#user_address_city',
    '#registration_State': '#user_address_state',
    '#registration_ZIP': '#user_address_zip',
    '#registration_country': '#user_address_country'
  };

  if ($(Object.keys(possibleRegFieldIDs).join(', ')).length > 0) {
    $('#copy_from_reg').removeClass('d-none');
  }

  $('#copy_from_reg').off('click');
  $('#copy_from_reg').on('click', function () {
    $.each(possibleRegFieldIDs, function (originalID, copyID) {
      const val = $(originalID).val();
      if (val !== undefined) $(copyID).val(val);
    });
  });
}

function bindCommonEvents() {
  console.log("binding common events");

  $("#payment_method").off("change", togglePaymentProcessor);
  $("#payment_method").on("change", togglePaymentProcessor);

  // Donation buttons
  if ($('input[name=amount_btn]:checked').val()) {
    changeAmount($('input[name=amount_btn]:checked').val());
  }

  $(document).off("change", 'input[name=amount_btn]');
  $(document).on("change", 'input[name=amount_btn]', function () {
    changeAmount($(this).val());
  });

  // Stretch Pool buttons
  $(document).off("change", 'input[name=sp_amount_btn]');
  $(document).on("change", 'input[name=sp_amount_btn]', function () {
    changeStretchPoolAmount($(this).val());
  });

  // Stretch Pool checkbox off
  $(document).off("change", "#add_to_stretch_pool");
  $(document).on("change", "#add_to_stretch_pool", function () {
    if (!$(this).is(":checked")) {
      $('input[name="sp_amount_btn"]').prop("checked", false);
      $('#sp_amount_input').val(0).prop("disabled", true);

      // Clear hidden fields
      $('input[name="stretch_pool_amount"]').val(0);
      $('input[name="stretch_pool_fee"]').val(0);

      displayTotals();
    }
  });

  $("#amount_input, #sp_amount_input, #cover_fee, #registration_amount")
    .off('blur keydown input change', displayTotals)
    .on('blur keydown input change', displayTotals);

  // Address country toggle (d-none instead of hide/show)
  $('#user_address_country').off("change");
  $('#user_address_country').on("change", function () {
    if ($(this).val() !== "US") {
      $('#user_address_state').prop('required', false);
      $('.address_state_field').addClass('d-none');
    } else {
      $('#user_address_state').prop('required', true);
      $('.address_state_field').removeClass('d-none');
    }
  });

  const required = document.getElementById("donation_options")?.dataset?.donationRequired === "true";
  if (required) {
    const checked = $('input[name=amount_btn]:checked').val();

    if (!checked) {
      // No selection yet → radios must be required
      document.querySelectorAll('input[name="amount_btn"]').forEach(r => r.required = true);
    } else {
      changeAmount(checked);
    }
  }

  displayTotals();
}

/* -------------------------------------------------------------------------- */
/* Payment Helpers                                                            */
/* -------------------------------------------------------------------------- */

function togglePaymentProcessor() {
  let payment_method = $("#payment_method").val();

  if (payment_method == "paypal") {
    $("#paypal_trust_badge").removeClass("d-none");
    $("#stripe_trust_badge").addClass("d-none");

    $("#submit_donation_btn").removeClass("stripe venmo").addClass("paypal");
    $("#payment_method_icon").removeClass("bi-stripe venmo_icon").addClass("bi-paypal");

  } else if(payment_method == "venmo") {
    $("#paypal_trust_badge").removeClass("d-none");
    $("#stripe_trust_badge").addClass("d-none");

    $("#submit_donation_btn").removeClass("stripe paypal").addClass("venmo");
    $("#payment_method_icon").removeClass("bi-stripe bi-paypal").addClass("venmo_icon");

  } else {
    $("#paypal_trust_badge").addClass("d-none");
    $("#stripe_trust_badge").removeClass("d-none");

    $("#submit_donation_btn").removeClass("paypal venmo").addClass("stripe");
    $("#payment_method_icon").removeClass("bi-paypal venmo_icon").addClass("bi-stripe");
  }
}

function displayTotals() {
  const fixedFee = parseFloat(ft_dataset.fixedFee);
  const percentFee = parseFloat(ft_dataset.percentFee);

  let registrationAmount = parseFloat($('#registration_amount').val()) || 0;
  let donationAmount = parseFloat($('#amount_input').val()) || 0;

  /* ------------------------------------------------------------------
     Stretch Pool Amount Normalization
  ------------------------------------------------------------------ */
  let stretchPoolAmount = 0;

  const spRadio = $('input[name="sp_amount_btn"]:checked').val();
  const spInput = parseFloat($('#sp_amount_input').val()) || 0;

  if ($('#add_to_stretch_pool').is(':checked')) {
    if (spRadio === "other") {
      stretchPoolAmount = spInput;
    } else {
      stretchPoolAmount = parseFloat(spRadio) || 0;
    }
  } else {
    stretchPoolAmount = 0;
  }

  // Sync hidden amount
  $('input[name="stretch_pool_amount"]').val(stretchPoolAmount);

  /* ------------------------------------------------------------------
     Cover Fee Logic
  ------------------------------------------------------------------ */
  let showFee = true;
  const coverFeeInput = $("#cover_fee");

  if (coverFeeInput.length === 1) {
    if (coverFeeInput.attr("type") === "checkbox") {
      showFee = coverFeeInput.is(":checked");
    }
  }

  /* ------------------------------------------------------------------
     Discounts
  ------------------------------------------------------------------ */
  const discount = calculateDiscount();
  registrationAmount -= discount;

  const autoDonationDiscount = calculateDonationDiscount();
  registrationAmount -= autoDonationDiscount;

  if (registrationAmount < 0) registrationAmount = 0;

  /* ------------------------------------------------------------------
     Separate Fee Calculations
  ------------------------------------------------------------------ */

  let fundraiserSubtotal = registrationAmount + donationAmount;
  let stretchSubtotal = stretchPoolAmount;

  let fundraiserFee = 0;
  let stretchPoolFee = 0;

  if (showFee && fundraiserSubtotal > 0) {
    fundraiserFee = (fundraiserSubtotal * (percentFee / 100)) + fixedFee;
  }

  if (showFee && stretchSubtotal > 0) {
    stretchPoolFee = (stretchSubtotal * (percentFee / 100)) + fixedFee;
  }

  // Update stretch pool hidden fee
  $('input[name="stretch_pool_fee"]').val(stretchPoolFee);

  const combinedFee = fundraiserFee + stretchPoolFee;

  const subtotal = fundraiserSubtotal + stretchSubtotal;
  const total = subtotal + combinedFee;

  /* ------------------------------------------------------------------
     UI Display
  ------------------------------------------------------------------ */

  if (stretchPoolAmount > 0) {
    $('#transaction_stretch_pool_donation')
      .text("Stretch pool donation: " + formatDollars(stretchPoolAmount))
      .removeClass('d-none');
  } else {
    $('#transaction_stretch_pool_donation').addClass('d-none');
  }

  if (registrationAmount > 0 || discount > 0) {
    let regText = "Registration cost: " + formatDollars(registrationAmount);

    if (discount > 0) {
      regText += " (" + formatDollars(discount) + " coupon applied)";
    }

    if (autoDonationDiscount > 0) {
      regText += " (" + formatDollars(autoDonationDiscount) + " discount applied)";
    }

    $('#transaction_registration')
      .text(regText)
      .removeClass('d-none');
  } else {
    $('#transaction_registration').addClass('d-none');
  }

  if (donationAmount > 0) {
    $('#transaction_donation')
      .text("Donation amount: " + formatDollars(donationAmount))
      .removeClass('d-none');
  } else {
    $('#transaction_donation').addClass('d-none');
  }

  if (subtotal > 0) {
    if (showFee) {
      $('#transaction_fee')
        .text("Processing fee: " + formatDollars(combinedFee))
        .removeClass('d-none');
    } else {
      $('#transaction_fee').addClass('d-none');
    }

    $('#transaction_total').text(formatDollars(total));
  } else {
    $('#transaction_fee').addClass('d-none');
    $('#transaction_total').text(formatDollars(0));
  }

  return subtotal;
}

function calculateDiscount() {
  const registrationAmount = parseFloat($('#registration_amount').val()) || 0;
  const discountPercent = parseFloat($('#coupon_discount_percent').val()) || 0;
  const discountDollars = parseFloat($('#coupon_discount_dollars').val()) || 0;

  if (registrationAmount === 0) return 0;

  if (discountPercent > 0) {
    return registrationAmount * (discountPercent / 100);
  }

  if (discountDollars > 0) {
    return discountDollars;
  }

  return 0;
}

function calculateDonationDiscount() {
  if (ft_dataset.enableThresholdDiscount !== 'true') return 0;

  const donationAmount = parseFloat($('#amount_input').val()) || 0;
  const registrationAmount = parseFloat($('#registration_amount').val()) || 0;

  const thresholdDollars = parseFloat(ft_dataset.thresholdAmountDollars) || 0;
  const discountDollars = parseFloat(ft_dataset.thresholdDiscountDollars) || 0;
  const discountPercent = parseFloat(ft_dataset.thresholdDiscountPercent) || 0;
  const minRegistrationDollars = parseFloat(ft_dataset.thresholdMinimumRegistrationDollars) || 0;

  if (donationAmount < thresholdDollars) return 0;
  if (registrationAmount < minRegistrationDollars) return 0;

  let reduction = 0;
  if (discountDollars > 0) reduction += discountDollars;
  if (discountPercent > 0) reduction += (registrationAmount * (discountPercent / 100.0));
  return reduction;
}

function applyCoupon() {
  const code = $('#coupon_code').val();
  const eventId = ft_dataset.eventId;
  const couponURL = `/check_coupon/${eventId}/${code}`;

  $('#coupon_discount_percent').val(0);
  $('#coupon_discount_dollars').val(0);
  $('#coupon_notice').slideUp();
  $('#coupon_notice').addClass("d-none");

  const subtotal = currentSubtotal();
  if (subtotal === 0) {
    $('#coupon_notice_text').text("Please choose your transaction options before applying a coupon.");
    $('#coupon_notice').slideDown();
    $('#coupon_notice').removeClass("d-none");
    return;
  }

  $.getJSON(couponURL, function (couponResponse) {
    if (couponResponse.error_text !== undefined) {
      $('#coupon_notice_text').text(couponResponse.error_text);
      $('#coupon_notice').slideDown();
      $('#coupon_notice').removeClass("d-none");
      return;
    }

    $('#coupon_discount_percent').val(couponResponse.discount_percent);
    $('#coupon_discount_dollars').val(couponResponse.discount_dollars);

    $('#coupon_notice_text').text(couponResponse.description);
    $('#coupon_notice').slideDown();
    $('#coupon_notice').removeClass("d-none");
  }).always(function () {
    displayTotals();
  });
}

function changeAmount(amountVal) {
  const required = document.getElementById("donation_options")?.dataset?.donationRequired === "true";
  const radios = document.querySelectorAll('input[name="amount_btn"]');
  const amountInput = document.getElementById("amount_input");

  if (amountVal === "other") {
    $('#amount_input').prop("disabled", false);
    $('#amount_input').val(5);
    $('#custom_donation_amount').slideDown('fast');

    if (required) {
      radios.forEach(r => r.required = false);
      amountInput.required = true;
    }

  } else {
    $('#amount_input').val(amountVal);
    $('#amount_input').prop("disabled", true);
    $('#custom_donation_amount').slideUp('fast');

    if (required) {
      radios.forEach(r => r.required = true);
      amountInput.required = false;
    }
  }

  displayTotals();
}

function changeStretchPoolAmount(value) {
  if (value === "other") {
    $('#sp_amount_input').prop("disabled", false);
    $('#sp_amount_input').val(5);
    $('#sp_custom_donation_amount').removeClass('d-none');
  } else {
    $('#sp_amount_input').prop("disabled", true);
    $('#sp_custom_donation_amount').addClass('d-none');
  }

  displayTotals();
}

function currentSubtotal() {
  const registrationAmount = parseFloat($('#registration_amount').val()) || 0;
  const donationAmount = parseFloat($('#amount_input').val()) || 0;
  const stretchPoolAmount = parseFloat($('input[name="stretch_pool_amount"]').val()) || 0;

  return registrationAmount + donationAmount + stretchPoolAmount;
}

function formatDollars(number) {
  return number.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
}

/* -------------------------------------------------------------------------- */
/* PayPal                                                                     */
/* -------------------------------------------------------------------------- */


/* -------------------------------------------------------------------------- */
/* Dependency + registration helpers                                          */
/* -------------------------------------------------------------------------- */

function checkDependencies(target, show) {
  let t = target;
  if (!t.hasClass('form_field')) {
    t = t.parents('.form_field');
  }

  if (t !== undefined && show !== undefined) {
    let dependent;
    let antiDependent;

    if (t.data('dependent-id')) {
      dependent = $('#' + t.data('dependent-id'));
      antiDependent = $('#not-' + t.data('dependent-id'));
    } else {
      dependent = $('.' + t.data('dependent-class'));
      antiDependent = $('.not-' + t.data('dependent-class'));
    }

    if (show === true) {
      dependent.slideDown('fast');
      antiDependent.slideUp('fast');
      clearFields(antiDependent);

      $('input.wasRequired').each(function () {
        $(this).attr('required', 'required');
        $(this).removeClass('wasRequired');
      });
    } else {
      dependent.slideUp('fast');
      clearFields(dependent);
      antiDependent.slideDown('fast');

      dependent.find('input').each(function () {
        if ($(this).attr('required') === 'required') {
          $(this).addClass('wasRequired');
          $(this).removeAttr('required');
        }
      });
    }
    return dependent;
  }
  return undefined;
}

function clearFields(target) {
  $(':input', target)
    .not(':button, :submit, :reset, :hidden')
    .val('')
    .prop('checked', false)
    .prop('selected', false);
}

function getDependencies(target) {
  const t = $(target);
  let show;

  if (t.prop('checked')) show = t.data('dependent-show');
  if (t.attr("type") === "checkbox") show = t.prop("checked");

  checkDependencies(t, show);
}

function checkRegOptions() {
  const activity = $('#options_activity').find('input:checked');
  const division = $('#options_division').find('input:checked');
  const numRegistrantsInput = $("input[name=num_registrants]:checked");

  if (activity.length === 1) {
    const isTriathlon = activity.attr('id').indexOf('tri') >= 0;
    if (isTriathlon) {
      $('#add_registrants').slideDown('fast');
    } else {
      $('#add_registrants').slideUp('fast');
      $('#add_registrants_details').slideUp('fast');
      $('#num_registrants_1').prop('checked', true);
    }
  }

  if (numRegistrantsInput.val()) {
    const numRegistrants = parseInt(numRegistrantsInput.val());
    if (numRegistrants > 1) {
      $('#add_registrants_details').slideDown('fast');
    } else {
      $('#add_registrants_details').slideUp('fast');
    }
  }

  if (activity.length === 1 && division.length === 1) {
    let cost = activity.data('cost');
    let description = activity.data('description') + ': ' + division.data('description') + ' division';

    if (numRegistrantsInput.val()) {
      const numRegistrants = parseInt(numRegistrantsInput.val());
      cost = cost * numRegistrants;
      if (numRegistrants > 1) {
        const additionalDesc = " + " + numRegistrantsInput.siblings("label").text();
        description += additionalDesc;
      }
    }

    $('#cost_confirm').slideDown('fast');
    $('.cost_confirm_amount').text(formatDollars(cost));
    $('#registration_amount').val(cost);

    $('.cost_confirm_description').text(description);
    $('#registration_description').val(description);
  } else {
    $('#cost_confirm').slideUp('fast');
    $('#registration_amount').val('');
    $('#registration_description').val('');
    $('#options_teammates').slideUp('fast');
  }
}

function checkDynamicRegOptions() {
  let total = 0.0;
  let description = [];
  let htmlDescription = "";
  let anyFree = false;

  const costfields = $('.registration_cost_field');

  for (let i = 0; i < costfields.length; i++) {
    const costfield = costfields[i];

    let data = {};
    let cost = 0.0;
    let desc = "";
    let free = false;

    const field = $(costfield);

    if ((field.is(':checkbox') || field.is(':radio')) && field.prop('checked')) {
      data = field.data();
    } else if (field.is('select')) {
      data = field.find('option:selected').data();
    }

    if (Object.keys(data).length > 0) {
      cost = parseFloat(data.cost);
      desc = data.description;
      free = data.free;

      if (free) anyFree = true;

      total += cost;
      htmlDescription += `• ${desc}<br/>`;
      description.push(desc);
    }
  }

  if (total > 0 || anyFree) {
    $('#cost_confirm').slideDown('fast');
    $('.cost_confirm_amount').text(formatDollars(total));
    $('#registration_amount').val(total);
    $('.cost_confirm_description').html(htmlDescription);
    $('#registration_description').val(description.join("; "));
  } else {
    $('#cost_confirm').slideUp('fast');
    $('#registration_amount').val('');
    $('#registration_description').val('');
  }

  displayTotals();
}
